/* ==========================================================================
  petition.js - Petition custom post type scripts.
========================================================================== */

"use strict";
/* global ajaxPetition, Toastify, Accordion */

/* -------------------------------------------------------
  Declare global DOM element used in multiple functions
---------------------------------------------------------*/

const petitionForm = document.getElementById("petitionForm");

/* -------------------------------------------------------
  Event listeners on windows load
---------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {

  if(petitionForm === null) {
    return;
  }

  petitionForm.addEventListener("submit", function (event) {
      event.preventDefault();

      const buttonAjax = document.querySelector(".button-ajax");
      buttonAjax.disabled = true;
      buttonAjax.classList.add("button-ajax--loading");
      // Prepare data for ajax request
      const formDatas = new FormData(this);
      formDatas.append("action", "submit_form_petition");
      formDatas.append("nonce", ajaxPetition.ajax_nonce);
      formDatas.append("post_id", ajaxPetition.post_id); // post_id is the current post ID

      fetch(ajaxPetition.ajax_url, {
        method: "POST",
        body: formDatas,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (response) {
          if (!response.success) {
            response.data.forEach((error) => {
              Toastify({
                text: error.message,
                className: "error",
                gravity: "bottom",
                position: "center",
              }).showToast();
            });
          } else {
            Toastify({
              text: response.data.message,
              className: "success",
              gravity: "bottom",
              position: "center",
            }).showToast();

            petitionForm.reset();

            // Redirect to the petition page
            window.location.href = response.data.redirect;
          }
        })
        .catch(function (error) {
          console.log(error.message);
        })
        .finally(function () {
          buttonAjax.disabled = false;
          buttonAjax.classList.remove(
            "button-ajax--loading"
          );
        });
    });

  // Progress bar animation
  const petitionProgress = document.getElementById("petitionProgress");
  const percentage = petitionProgress.dataset.percentage;
  petitionProgress.style.width = percentage + "%";
});
